import {DestroyRef, inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable, timer} from 'rxjs';
import DevExpress from 'devextreme';
import ToastType = DevExpress.ui.dxToast.ToastType;
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Injectable({providedIn: 'root'})
export class ToastService {
  private isVisibleSubject:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private typeSubject: BehaviorSubject<ToastType> = new BehaviorSubject<ToastType>('info');
  private messageSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  isVisible$: Observable<boolean> = this.isVisibleSubject.asObservable();
  type$: Observable<ToastType> = this.typeSubject.asObservable();
  message$: Observable<string> = this.messageSubject.asObservable();

  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  private pendingMessages: string[] = [];
  private showTimerActive: boolean = false;

  showToast(message: string, type: ToastType): void {
    if (type === 'error') {
      this.pendingMessages.push(message);

      if (this.showTimerActive) return;
      this.showTimerActive = true;

      timer(50).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        const combined: string = this.pendingMessages.join(' ');
        this.messageSubject.next(combined);
        this.typeSubject.next('error');
        this.isVisibleSubject.next(true);

        timer(4000).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
          this.isVisibleSubject.next(false);
          this.typeSubject.next('info');
          this.messageSubject.next('');
          this.pendingMessages = [];
          this.showTimerActive = false;
        });
      });
    } else {
      // non-error toasts show instantly
      this.messageSubject.next(message);
      this.typeSubject.next(type);
      this.isVisibleSubject.next(true);

      timer(3000).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.isVisibleSubject.next(false);
        this.typeSubject.next('info');
        this.messageSubject.next('');
      });
    }
  }
}
